import Vue from 'vue'

import { Component, Watch } from 'vue-property-decorator'
import { State } from 'vuex-class'

import { ticketStatus, ticketPriority, codesMap } from '@/modules/Ticket/helpers/ticket'
import { ApolloResponse } from '@/interfaces/apollo'
import { Breadcrumb } from '@/interfaces/breadcrumbs'
import { SnackType } from '@/interfaces/snack'
import { Ticket, ReducedTicket } from '@/modules/Ticket/interfaces/ticket'
import { History } from '@/modules/History/interfaces/history'
import { ReducedUser, User } from '@/modules/User/interfaces/user'
import { ReducedLabel } from '@/modules/Label/interfaces/label'
import { FileToSave } from '@/modules/File/interfaces/file'
import { TicketAttachment } from '@/modules/Ticket/interfaces/ticket-attachment'
import { showErrors, showNotification } from '@/utils/snack'
import { dateTimeToDisplay, dateTimeToUnix, dateToDisplay } from '@/utils/dateTime'
import { fileSizeFormat } from '@/utils/fileSize'
import { unescapeLineBreak, escapeLineBreak } from '@/utils/stringParser'
import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue'
import TicketProps from '@/modules/Ticket/components/TicketProps.vue'
import AppDialog from '@/components/AppDialog.vue'
import AppMarkdownEditor from '@/components/AppMarkdownEditor.vue'
import { getTicketById, editTicketName, editTicketContent, editTicketExpectedTime, editTicketPriority, commentToTicketById, editComment, completeTicketById, closeTicketById, reopenTicketById, reprocessTicketById, deleteTicketById, updateRelatedUsers, updateTicketLabels, relateTicket } from '@/modules/Ticket/gql/ticket.gql'

@Component({
  components: {
    AppBreadcrumbs,
    TicketProps,
    AppDialog,
    AppMarkdownEditor
  }
})
export default class TicketDetail extends Vue {
  breadcrumbs: Breadcrumb[] = [
    {
      text: `Ticket`,
      to: { name: 'TicketDashborad' }
    }
  ]
  ticketId = 0

  ticket: Ticket | null = null

  activeDelete = false
  activeRename = false
  activeComplete = false
  activeLock = false
  activeUnlock = false
  activeProcess = false

  ticketEdit: any = {
    name: null,
    content: null,
    expectedTime: null,
    priority: null,
    labels: null,
    assignees: null,
    supervisors: null,
    relatedTickets: null
  }

  editNameState = false

  dialogShow = false
  disableConfirm = false
  dialogType = ''
  dialogTitle = {
    'complete': 'Complete Ticket',
    'delete': 'Delete Ticket',
    'close': 'Close Ticket',
    'editDetail': 'Edit Detail'
  }
  dialogParams: any = {}

  comment = {
    text: '',
    files: [],
    filesToDel: [],
    filesToSave: [],
    editting: true
  }

  codesMap = codesMap
  ticketPriority = ticketPriority
  ticketStatus = ticketStatus

  get isFounders () {
    if (!this.ticket) {
      return false
    }
    const { me } = this
    const { supervisors, founder } = this.ticket
    if (!me || !founder) {
      return false
    }
    if (me.id === founder.id) {
      return true
    }
    for (const supervisor of supervisors) {
      if (supervisor.id === me.id) {
        return true
      }
    }
    return false
  }

  @State(state => state.user.me) me!: User

  dateTimeToDisplay = dateTimeToDisplay
  dateToDisplay = dateToDisplay
  fileSizeFormat = fileSizeFormat

  mounted () {
    this.pageInit()
  }

  @Watch('ticket')
  onTicketChanged (val: Ticket) {
    this.ticketEdit = {
      name: val.name,
      content: val.content || '',
      expectedTime: val.expectedTime,
      priority: val.priority,
      labels: val.labels,
      assignees: val.assignees,
      supervisors: val.supervisors,
      relatedTickets: val.relatedTickets,
      detail: Object.assign({}, val.detail)
    }
  }

  @Watch('$route.params.id')
  onRouteChanged (val: any, oldVal: any) {
    this.pageInit()
  }

  pageInit () {
    this.ticketId = Number(this.$route.params.id)
    if (this.breadcrumbs.length === 1) {
      this.breadcrumbs.push({
        text: this.ticketId
      })
    } else {
      this.breadcrumbs[1].text = this.ticketId
    }
    this.getTicketDetail()
  }

  async getTicketDetail () {
    const { ticketId } = this
    try {
      const result: ApolloResponse = await this.$apollo.query({
        query: getTicketById,
        variables: {
          ticketId
        }
      })
      if (!result.data) {
        showErrors(result.errors)
        return
      }
      const ticket = result.data.getTicketById
      ticket.founder = ticket.users.founder
      ticket.assignees = ticket.users.assignees
      ticket.supervisors = ticket.users.supervisors
      this.ticket = this.parseHistories(ticket)
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  async getTicketHistories () {

  }

  parseHistories (ticket: Ticket): Ticket {
    const { histories } = ticket
    const parsedHistories: History[] = histories.map((history: any) => {
      const additional = JSON.parse(history.additionalInfo)
      if (history.actionCode === '0212') {
        additional.detail = {
          text: unescapeLineBreak(additional.content),
          files: additional.attachments,
          filesToDel: [],
          filesToSave: [],
          editting: false
        }
        additional.detailEdit = {
          text: unescapeLineBreak(additional.content),
          files: additional.attachments,
          filesToDel: [],
          filesToSave: [],
          editting: false
        }
      }
      return this.$R.merge(history, {
        additional
      })
    })
    const attachments = parsedHistories[0].additional.attachments
    ticket.detail = {
      text: unescapeLineBreak(ticket.content || ''),
      files: attachments || [],
      filesToDel: [],
      filesToSave: [],
      editting: false
    }
    ticket.histories = parsedHistories
    return ticket
  }

  parseHistory (history: History): History {
    const additional = JSON.parse(history.additionalInfo)
    if (history.actionCode === '0212') {
      additional.detail = {
        text: unescapeLineBreak(additional.content),
        files: additional.attachments,
        filesToDel: [],
        filesToSave: [],
        editting: false
      }
      additional.detailEdit = {
        text: unescapeLineBreak(additional.content),
        files: additional.attachments,
        filesToDel: [],
        filesToSave: [],
        editting: false
      }
    }
    return this.$R.merge(history, {
      additional
    })
  }

  matchSrc (code: string) {
    switch (code) {
      case '0210':
        return require('@/assets/icon_ticket_action_close.png')
      case '0200':
        return require('@/assets/v2/icon_unlock.png')
      case '0219':
        return require('@/assets/icon_ticket_action_label.png')
      case '0202':
        return require('@/assets/icon_ticket_action_rename.png')
      case '0203':
        return require('@/assets/icon_ticket_action_time.png')
      case '0213':
        return require('@/assets/icon_ticket_action_assign.png')
      case '0217':
        return require('@/assets/icon_ticket_action_relate.png')
      case '0215':
        return require('@/assets/icon_ticket_action_supervisor.png')
      case '0221':
        return require('@/assets/icon_ticket_action_priority.png')
      case '0204':
        return require('@/assets/icon_ticket_action_content.png')
      case '0222':
        return require('@/assets/icon_ticket_action_content.png')
      case '0223':
        return require('@/assets/v2/icon_unlock.png')
      case '0224':
        return require('@/assets/icon_ticket_action_reprocess.png')
      case '0211':
        return require('@/assets/icon_ticket_action_complete.png')
      default:
        break
    }
  }

  propsChangedHandler (type: string) {
    setTimeout(() => {
      switch (type) {
        case 'date':
          this.changeExpectedTime()
          break
        case 'assignee':
          this.updateAssignees()
          break
        case 'supervisor':
          this.updateSupervisors()
          break
        case 'related':
          this.updateRelatedTickets()
          break
        case 'label':
          this.updateLabels()
          break
        case 'priority':
          this.changePriority()
          break
        default:
          break
      }
    }, 1000)
  }

  renameTicket () {
    this.editNameState = !this.editNameState
  }
  async renameConfirm () {
    const { id } = this.$route.params
    const { name } = this.ticketEdit
    try {
      const result = await this.$apollo.mutate({
        mutation: editTicketName,
        variables: {
          ticketId: Number(id),
          newName: name
        }
      })
      this.editNameState = false
      if (!this.ticket) {
        return
      }
      showNotification({
        msg: 'Rename ticket successfully',
        type: SnackType.Success
      })
      const history = this.parseHistory(result.data.editTicketName)
      this.ticket.name = name
      this.ticket.histories.push(history)
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }
  renameCancel () {
    this.editNameState = false
  }

  async changeExpectedTime () {
    const { id } = this.$route.params
    const { expectedTime } = this.ticketEdit
    try {
      const result = await this.$apollo.mutate({
        mutation: editTicketExpectedTime,
        variables: {
          expectedTime: dateTimeToUnix(expectedTime || '') + '',
          ticketId: Number(id)
        }
      })
      if (!this.ticket) {
        return
      }
      showNotification({
        msg: 'Change expected time successfully',
        type: SnackType.Success
      })
      const history = this.parseHistory(result.data.editTicketExpectedTime)
      this.ticket.histories.push(history)
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  async updateAssignees () {
    const { id } = this.$route.params
    const { assignees } = this.ticketEdit
    if (!this.ticket || this.sameCheck(this.ticket.assignees, assignees)) {
      return
    }
    let usernames: string[] = []
    let ids: number[] = []
    assignees.map((user: ReducedUser) => {
      usernames.push(user.username)
      ids.push(user.id)
    })
    try {
      const result = await this.$apollo.mutate({
        mutation: updateRelatedUsers,
        variables: {
          userIds: ids,
          usernames: usernames,
          ticketId: Number(id),
          type: 'ASSIGNEE'
        }
      })
      if (!this.ticket) {
        return
      }
      showNotification({
        msg: 'Set assignees successfully',
        type: SnackType.Success
      })
      const history = this.parseHistory(result.data.updateRelatedUsers)
      this.ticket.assignees = assignees.concat([])
      this.ticket.histories.push(history)
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  async updateSupervisors () {
    const { id } = this.$route.params
    const { supervisors } = this.ticketEdit
    if (!this.ticket || this.sameCheck(this.ticket.supervisors, supervisors)) {
      return
    }
    let usernames: string[] = []
    let ids: number[] = []
    supervisors.map((user: ReducedUser) => {
      usernames.push(user.username)
      ids.push(user.id)
    })
    try {
      const result = await this.$apollo.mutate({
        mutation: updateRelatedUsers,
        variables: {
          userIds: ids,
          usernames: usernames,
          ticketId: Number(id),
          type: 'SUPERVISOR'
        }
      })
      if (!this.ticket) {
        return
      }
      showNotification({
        msg: 'Set supervisors successfully',
        type: SnackType.Success
      })
      const history = this.parseHistory(result.data.updateRelatedUsers)
      this.ticket.supervisors = supervisors.concat([])
      this.ticket.histories.push(history)
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  async updateLabels () {
    const { id } = this.$route.params
    const { labels } = this.ticketEdit
    if (!this.ticket || this.sameCheck(this.ticket.labels, labels)) {
      return
    }
    let ids: number[] = labels.map((label: ReducedLabel) => Number(label.id))
    try {
      const result = await this.$apollo.mutate({
        mutation: updateTicketLabels,
        variables: {
          labelIds: ids,
          ticketId: Number(id)
        }
      })
      if (!this.ticket) {
        return
      }
      showNotification({
        msg: 'Set labels successfully',
        type: SnackType.Success
      })
      const history = this.parseHistory(result.data.updateLabels)
      this.ticket.labels = labels.concat([])
      this.ticket.histories.push(history)
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  async changePriority () {
    const { id } = this.$route.params
    const { priority } = this.ticketEdit
    try {
      const result = await this.$apollo.mutate({
        mutation: editTicketPriority,
        variables: {
          priority,
          ticketId: Number(id)
        }
      })
      if (!this.ticket) {
        return
      }
      showNotification({
        msg: 'Change priority successfully',
        type: SnackType.Success
      })
      const history = this.parseHistory(result.data.editTicketPriority)
      this.ticket.histories.push(history)
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  async updateRelatedTickets () {
    const { id } = this.$route.params
    const { relatedTickets } = this.ticketEdit
    if (!this.ticket || this.sameCheck(this.ticket.relatedTickets, relatedTickets)) {
      return
    }
    let ticketsStr: ReducedTicket[] = []
    relatedTickets.map((ticket: any) => {
      const ticketItem: ReducedTicket = {
        id: Number(ticket.id),
        name: ticket.name
      }
      ticketsStr.push(ticketItem)
    })
    try {
      const result = await this.$apollo.mutate({
        mutation: relateTicket,
        variables: {
          relatedTickets: ticketsStr,
          ticketId: Number(id)
        }
      })
      if (!this.ticket) {
        return
      }
      showNotification({
        msg: 'Set related tickets successfully',
        type: SnackType.Success
      })
      const history = this.parseHistory(result.data.relateTicket)
      this.ticket.relatedTickets = relatedTickets.concat([])
      this.ticket.histories.push(history)
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  editTicketContent () {
    this.ticketEdit.detail.editting = !this.ticketEdit.detail.editting
  }

  cancelEditContent () {
    if (this.ticket && this.ticket.detail) {
      const { text, files } = this.ticket.detail
      this.ticketEdit.detail.text = text
      this.ticketEdit.detail.files = files
      this.ticketEdit.detail.filesToSave = []
      this.ticketEdit.detail.editting = !this.ticketEdit.detail.editting
    }
  }

  async submitEditContent () {
    const { id } = this.$route.params
    const { text, files, filesToSave } = this.ticketEdit.detail
    const content = escapeLineBreak(text)
    const fileIds = files.map((file: TicketAttachment) => file.id)

    let filesStr: FileToSave[] = []

    filesToSave.map((file: FileToSave) => {
      const fileItem: FileToSave = {
        url: file.url,
        name: file.name,
        size: file.size.toString(),
        type: 'TICKET_ATTACHMENT'
      }
      filesStr.push(fileItem)
    })

    this.ticketEdit.detail.editting = false
    try {
      const result = await this.$apollo.mutate({
        mutation: editTicketContent,
        variables: {
          content,
          ticketId: Number(id),
          fileIds,
          newFiles: filesStr
        }
      })
      if (!this.ticket || !this.ticket.detail) {
        return
      }
      showNotification({
        msg: 'Update ticket detail successfully',
        type: SnackType.Success
      })
      const history = this.parseHistory(result.data.editTicketContent)
      this.ticket.detail.text = text
      this.ticket.detail.files = history.additional.attachments || []
      this.ticket.detail.filesToSave = []
      this.ticketEdit.detail.text = text
      this.ticketEdit.detail.files = history.additional.attachments || []
      this.ticketEdit.detail.filesToSave = []
      this.ticket.histories.push(history)
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  async newComment () {
    const { id } = this.$route.params
    const { text, filesToSave } = this.comment
    const content = escapeLineBreak(text)

    let filesStr: FileToSave[] = []

    filesToSave.map((file: FileToSave) => {
      const fileItem: FileToSave = {
        url: file.url,
        name: file.name,
        size: file.size.toString(),
        type: 'TICKET_ATTACHMENT'
      }
      filesStr.push(fileItem)
    })

    try {
      const result = await this.$apollo.mutate({
        mutation: commentToTicketById,
        variables: {
          content,
          ticketId: Number(id),
          files: filesStr
        }
      })
      if (!this.ticket) {
        return
      }
      showNotification({
        msg: 'Comment to ticket successfully',
        type: SnackType.Success
      })
      this.comment = {
        text: '',
        files: [],
        filesToDel: [],
        filesToSave: [],
        editting: true
      }
      const history = this.parseHistory(result.data.commentToTicketById)
      this.ticket.histories.push(history)
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  editComment (index: number) {
    if (!this.ticket) {
      return
    }
    this.ticket.histories[index].additional.detailEdit.editting = !this.ticket.histories[index].additional.detailEdit.editting
  }

  cancelEditComment (e: Event, index: number) {
    e.preventDefault()
    e.stopPropagation()
    if (this.ticket) {
      const { text, files } = this.ticket.histories[index].additional.detail
      this.ticket.histories[index].additional.detailEdit.text = text
      this.ticket.histories[index].additional.detailEdit.files = files
      this.ticket.histories[index].additional.detailEdit.filesToSave = []
      this.ticket.histories[index].additional.detailEdit.editting = !this.ticket.histories[index].additional.detailEdit.editting
    }
  }

  async editCommentSubmit (index: number) {
    const { id } = this.$route.params
    if (!this.ticket) {
      return
    }
    const historyId = this.ticket.histories[index].id
    const { text, files, filesToSave } = this.ticket.histories[index].additional.detailEdit
    const content = escapeLineBreak(text)
    const fileIds = files.map((file: TicketAttachment) => file.id)

    let filesStr: FileToSave[] = []

    filesToSave.map((file: FileToSave) => {
      const fileItem: FileToSave = {
        url: file.url,
        name: file.name,
        size: file.size.toString(),
        type: 'TICKET_ATTACHMENT'
      }
      filesStr.push(fileItem)
    })
    this.ticket.histories[index].additional.detailEdit.editting = false
    try {
      const result = await this.$apollo.mutate({
        mutation: editComment,
        variables: {
          content,
          ticketId: Number(id),
          historyId: Number(historyId),
          fileIds,
          newFiles: filesStr
        }
      })
      if (!this.ticket) {
        return
      }
      showNotification({
        msg: 'Update comment successfully',
        type: SnackType.Success
      })
      const history = this.parseHistory(result.data.editComment)
      this.ticket.histories[index].additional.detail.files = history.additional.attachments || []
      this.ticket.histories[index].additional.detail.filesToSave = []
      this.ticket.histories[index].additional.detailEdit.files = history.additional.attachments || []
      this.ticket.histories[index].additional.detailEdit.filesToSave = []
      this.ticket.histories.push(history)
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  showDialog (type: string) {
    this.dialogType = type
    this.dialogShow = true
  }

  hideDialog () {
    this.dialogShow = false
    this.dialogType = ''
  }

  dialogConfirm (type: string) {
    switch (type) {
      case 'complete':
        this.completeTicketConfirm()
        break
      case 'close':
        this.closeTicketConfirm()
        break
      case 'delete':
        this.deleteTicketConfirm()
        break
      default:
        break
    }
  }

  deleteTicket () {
    this.showDialog('delete')
  }

  async deleteTicketConfirm () {
    const { id } = this.$route.params
    this.hideDialog()
    try {
      const result = await this.$apollo.mutate({
        mutation: deleteTicketById,
        variables: {
          ticketId: Number(id)
        }
      })
      const res = result.data.deleteTicketById
      if (!res) {
        return
      }
      showNotification({
        msg: 'Ticket complete successfully',
        type: SnackType.Success
      })
      this.$router.replace({
        name: 'TicketDashborad'
      })
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  completeTicket () {
    this.showDialog('complete')
  }

  async completeTicketConfirm () {
    const { id } = this.$route.params
    this.hideDialog()
    try {
      const result = await this.$apollo.mutate({
        mutation: completeTicketById,
        variables: {
          ticketId: Number(id)
        }
      })
      if (!this.ticket) {
        return
      }
      const res = result.data.completeTicketById
      if (!res) {
        return
      }
      this.ticket.status = 'COMPLETE'
      showNotification({
        msg: 'Ticket complete successfully',
        type: SnackType.Success
      })
      const history = {
        id: '',
        actionCode: '0211',
        additionalInfo: '{}',
        additional: {},
        user: {
          id: this.me.id,
          username: this.me.username
        }
      }
      this.ticket.histories.push(history)
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  async reprocessTicket () {
    const { id } = this.$route.params
    this.hideDialog()
    try {
      const result = await this.$apollo.mutate({
        mutation: reprocessTicketById,
        variables: {
          ticketId: Number(id)
        }
      })
      if (!this.ticket) {
        return
      }
      const res = result.data.reprocessTicketById
      if (!res) {
        return
      }
      this.ticket.status = 'PROCESSING'
      showNotification({
        msg: 'Ticket reopened successfully',
        type: SnackType.Success
      })
      const history = {
        id: '',
        actionCode: '0224',
        additionalInfo: '{}',
        additional: {},
        user: {
          id: this.me.id,
          username: this.me.username
        }
      }
      this.ticket.histories.push(history)
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  closeTicket () {
    this.showDialog('close')
  }

  async closeTicketConfirm () {
    const { id } = this.$route.params
    this.hideDialog()
    try {
      const result = await this.$apollo.mutate({
        mutation: closeTicketById,
        variables: {
          ticketId: Number(id)
        }
      })
      if (!this.ticket) {
        return
      }
      const res = result.data.closeTicketById
      if (!res) {
        return
      }
      this.ticket.closed = true
      showNotification({
        msg: 'Ticket closed successfully',
        type: SnackType.Success
      })
      const history = {
        id: '',
        actionCode: '0210',
        additionalInfo: '{}',
        additional: {},
        user: {
          id: this.me.id,
          username: this.me.username
        }
      }
      this.ticket.histories.push(history)
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  async reopenTicket () {
    const { id } = this.$route.params
    this.hideDialog()
    try {
      const result = await this.$apollo.mutate({
        mutation: reopenTicketById,
        variables: {
          ticketId: Number(id)
        }
      })
      if (!this.ticket) {
        return
      }
      const res = result.data.reopenTicketById
      if (!res) {
        return
      }
      this.ticket.closed = false
      showNotification({
        msg: 'Ticket reopened successfully',
        type: SnackType.Success
      })
      const history = {
        id: '',
        actionCode: '0223',
        additionalInfo: '{}',
        additional: {},
        user: {
          id: this.me.id,
          username: this.me.username
        }
      }
      this.ticket.histories.push(history)
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  withoutFirst (items: any[]) {
    return this.$R.drop(1, items)
  }

  sameCheck (oldVal: any[], newVal: any[]) {
    if (oldVal.length !== newVal.length) {
      return false
    }
    for (let i = 0; i < oldVal.length; i++) {
      if (!this.$R.find((val: any) => {
        return Number(val.id) === Number(oldVal[i].id)
      })(newVal)) {
        return false
      }
    }
    return true
  }
}
